import React, { useState } from 'react';

import { type NodeData, PeacockData } from './GraphData';
import PeacockGraph from './SemicircularGraph';
import StaticRadialGraph from './StaticGraph';

/**
 *
 */
function NetworkGraph() {
  const [nodeStack, setNodeStack] = useState<NodeData[]>([]);

  const findNodeByName = (node: NodeData, id: string): NodeData | null => {
    if (node.id === id) {
      return node;
    }

    if (node.children) {
      let found: NodeData | null = null;

      node.children.some((child) => {
        found = findNodeByName(child, id);

        return found !== null;
      });

      return found;
    }

    return null;
  };

  const handleNodeClick = (node: NodeData) => {
    setNodeStack((prev) => [...prev, node]);
  };

  const handleBack = () => {
    setNodeStack((prev) => prev.slice(0, -1));
  };

  const currentNode = nodeStack[nodeStack.length - 1] || null;

  return (
    <div className='NetworkGraph'>
      {!currentNode && (
        <StaticRadialGraph
          onNodeClick={(id) => {
            const node = findNodeByName(PeacockData, id);

            if (node) {
              setNodeStack([node]);
            }
          }}
          data={PeacockData}
        />
      )}
      {currentNode && (
        <PeacockGraph
          data={currentNode}
          onBack={handleBack}
          onNodeClick={handleNodeClick}
        />
      )}
    </div>
  );
}

export default NetworkGraph;
